import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import * as L from 'leaflet';
import 'leaflet-boundary-canvas';
import { TenantService } from "../../services/tenant.service";
import { DOCUMENT } from "@angular/common";
import { TenantRecords } from "../../../../interfaces/app";
import { AppDataService } from "../../../../shared/services/app-data.service";
import { StoreService } from "../../../../shared/services/store.service";
import UtilityFunctions from "../../../../utilities/functions";
import { environment } from "../../../../../environments/environment";
import { MainDataService } from "../../../../shared/services/main-data.service";
import { TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-tenant-configuration',
  templateUrl: './tenant-configuration.component.html',
  styleUrls: ['./tenant-configuration.component.scss']
})
export class TenantConfigurationComponent implements OnInit {
  countriesList: any;
  @ViewChild('map', { static: true }) mapElement: ElementRef;
  public searchCountry: string = '';
  allCountries: any = []
  private countryLayer: L.GeoJSON;
  private imageLayer: L.ImageOverlay
  private map: L.Map;
  private highlightedCountryLayer: L.Layer | null = null;
  private _BaseURL = environment.apiEndPoint;
  uniqueLanguagesArray: any[];
  userLang: string;
  selectedLang: string | undefined;
  constructor(private translate: TranslateService, private tenantService: TenantService, @Inject(DOCUMENT) document: Document, private appDataService: AppDataService, private store: StoreService, private mainDataService: MainDataService, private cd: ChangeDetectorRef, private activatedRoute: ActivatedRoute,) {
    this.activatedRoute.queryParams.subscribe(queryParams => {
      if (queryParams?.tenantId) {
        this.tenantService.setTenant(queryParams?.tenantId);

      }
    })
  }

  ngOnInit(): void {


    this.userLang = navigator.language;
    localStorage.setItem("browserLanguage", this.userLang == 'en-US' ? 'en' : this.userLang)
    this.mainDataService.browserLanguge = localStorage.getItem("browserLanguage");

    this.translate.use(this.mainDataService.browserLanguge);
    //
    this.mainDataService.getAllCountryTenants().subscribe((res: any) => {
      if (res?.data?.records) {
        this.countriesList = res.data.records;
        
        this.allCountries = JSON.parse(JSON.stringify(this.countriesList));
        this.uniqueLanguagesArray = [];
        console.log('this.allCountries',this.allCountries);

        this.countriesList.forEach((record: any) => {
          record.languages.forEach((language: any) => {

            const existingLanguage = this.uniqueLanguagesArray.find(item => item.name === language.name);
            if (!existingLanguage) {
              this.uniqueLanguagesArray.push({ name: language.name, code: language.code });

            }
          });
        });

        this.cd.markForCheck();
        this.cd.detectChanges();

        this.uniqueLanguagesArray.forEach((item: any) => {
          if (this.userLang === item.code) {
            this.selectedLang = item.code
          }
        })

      }


    })
    this.map = L.map('map', { zoomControl: false }).setView([-30, 50], 3,);
    this.map.scrollWheelZoom.disable();
    this.map.doubleClickZoom.disable();
    this.map.dragging.disable();
    this.map.boxZoom.disable();
    this.map.keyboard.disable();
    fetch('./assets/africa.geojson')
      .then(response => response.json())
      .then(data => {

        const africanCountries = data.features.filter((feature: any) => feature.properties.continent === 'Africa');


        L.geoJSON(africanCountries, {
          style: {
            fillColor: 'white',
            fillOpacity: 1,

            color: 'grey', // Set the boundary color
            weight: 2,

          },
        }).addTo(this.map).on('add remove', (layer) => {

          this.countryLayer = layer.target;
        });

      });
    this.map.on('mousedown', function (e) {

    });
  }
  changeLang(lang: any): void {
    //
    localStorage.setItem("browserLanguage", lang?.value == 'en-US' ? 'en' : lang?.value)
    this.mainDataService.browserLanguge = localStorage.getItem("browserLanguage")
    this.translate.use(lang?.value);
  }

  searchCountries(event: any) {
    if (this.country.length >= 1) {
      const normalizedCountry = this.removeDiacritics(this.searchCountry.toLowerCase());
      this.countriesList = this.allCountries.filter((item: any) =>
        this.removeDiacritics(item.name.toLowerCase()).includes(normalizedCountry)
      );
      console.log(this.countriesList);
      

    } else if (this.country.length === 0) {
      this.countriesList = this.allCountries;
    }
  }
  removeDiacritics(text: any) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }





  resetHighlight() {
    if (this.highlightedCountryLayer) {
      this.countryLayer.resetStyle(this.highlightedCountryLayer);
      this.highlightedCountryLayer = null;
    }
  }

  country(item: any) {

    fetch('./assets/africa.geojson')
      .then(response => response.json())
      .then(data => {



        const country = data.features.filter((feature: any) => feature.properties.iso_a2 === item.isoCode);
        const otherCountries = data.features.filter((feature: any) => feature.properties.iso_a2 !== item.isoCode);

        this.fillColor(country, 'yellow');
        this.fillColor(otherCountries, 'white');


      });
  }

  fillColor(countries: any, color: string) {
    L.geoJSON(countries, {
      style: {
        fillColor: color,
        fillOpacity: 1,

        color: 'grey', // Set the boundary color
        weight: 2,

      },
    }).addTo(this.map).on('add remove', (layer) => {

      this.countryLayer = layer.target;
    });

  }

  mouseLeave() {
    fetch('./assets/africa.geojson')
      .then(response => response.json())
      .then(data => {

        const otherCountries = data.features.filter((feature: any) => feature.properties.continent === 'Africa');


        L.geoJSON(otherCountries, {
          style: {
            fillColor: "white",
            fillOpacity: 1,

            color: 'grey', // Set the boundary color
            weight: 2,

          },
        }).addTo(this.map).on('add remove', (layer) => {

          this.countryLayer = layer.target;
        });

      });
  }

  setTenant(tenantId: any) {
    this.tenantService.setTenant(tenantId);
  }

  countryFlagImages(img: any) {
    return UtilityFunctions.verifyImageURL(img, this._BaseURL);

  }
  navigateToSellerHub() {
    window.open(environment.merchantURL + '?tenantId=' + `${localStorage.getItem('tenantId')}`, '_blank');
  }
}
//
// = [{
//   flag: "assets/flags/ghana.png",
//   tenantId: "2",
//   countryIso: "GH",
//   countryName: "Ghana"
// },
//   {
//     flag: "assets/flags/uganda.png",
//     tenantId: "1",
//     countryIso: "UG",
//     countryName: "Uganda"
//   },
//   {
//     flag: "assets/flags/Côte d'Ivoire.png",
//     tenantId: "4",
//     countryIso: "CI",
//     countryName: "Côte d'Ivoire"
//   }]
